import { SmartPhones, Container } from "../../components";
import "./styles.scss";

export const CategoriaSmartphones = () => (
  <Container className="smartphones" header titulo="SMARTPHONES">
    <SmartPhones />
  </Container>
);
